import { BLOCK } from "../../../types";
import { StructureBrush } from "../brush";
import type { StructureBuilder } from "../types";

export const buildWell: StructureBuilder = (world, spot) => {
    const brush = new StructureBrush(world, spot);

    brush.layer(1, 3, 1, 3, 0, BLOCK.Stone, (x, _y, z) => x !== 2 || z !== 2);
    brush.block(2, 0, 2, BLOCK.Water);

    const posts: [number, number][] = [
        [1, 1],
        [3, 1],
        [1, 3],
        [3, 3],
    ];
    for (const [dx, dz] of posts) {
        brush.column(dx, dz, 1, 3, BLOCK.StructureLog);
    }
    brush.layer(0, 4, 0, 4, 4, BLOCK.Thatch);
    brush.layer(1, 3, 1, 3, 5, BLOCK.Thatch);
};
